import { createWrapBasic } from '@/scopes/wrappers/createWrapBasic.js';

import { COMPONENT_NAME } from './const.js';

export const wrapBasic = createWrapBasic(COMPONENT_NAME);
